'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('./_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var Box = require('@mui/material/Box');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Box__default = /*#__PURE__*/_interopDefaultLegacy(Box);

var _excluded = ["size", "src", "alt", "forceStroke", "forceFill", "replaceColor", "replaceFillColor", "replaceStrokeColor", "className", "_className"];

var ImageWrapper = function ImageWrapper(_ref) {
  var size = _ref.size,
      src = _ref.src;
      _ref.alt;
      var forceStroke = _ref.forceStroke,
      forceFill = _ref.forceFill,
      replaceColor = _ref.replaceColor,
      replaceFillColor = _ref.replaceFillColor,
      replaceStrokeColor = _ref.replaceStrokeColor,
      className = _ref.className,
      _className = _ref._className,
      props = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var width;

  if (size !== undefined) {
    if (Number.isInteger(Number(size))) {
      width = Number(size);
    } else {
      switch (size) {
        case 'small':
          width = 24;
          break;

        case 'medium':
          width = 40;
          break;

        case 'large':
          width = 60;
          break;

        default:
          width = size;
      }
    }

    src = src.replace(/svg width="[0-9]+(?=")/, "svg width=\"" + width);
    src = src.replace(/height="[0-9]+(?=" viewBox)/, "height=\"" + width);
  }

  if (forceFill) {
    src = src.replace(/fill=".*?"/g, "fill=\"".concat(forceFill, "\""));
  }

  if (forceStroke) {
    src = src.replace(/stroke=".*?"/g, "stroke=\"".concat(forceStroke, "\""));
  }

  if (replaceColor) {
    replaceColor.forEach(function (item) {
      var _item = _rollupPluginBabelHelpers.slicedToArray(item, 2),
          fromColor = _item[0],
          toColor = _item[1];

      src = src.replaceAll("fill=\"".concat(fromColor, "\""), "fill=\"".concat(toColor, "\""));
      src = src.replaceAll("stroke=\"".concat(fromColor, "\""), "stroke=\"".concat(toColor, "\""));
    });
  }

  if (replaceFillColor) {
    replaceFillColor.forEach(function (item) {
      var _item2 = _rollupPluginBabelHelpers.slicedToArray(item, 2),
          fromColor = _item2[0],
          toColor = _item2[1];

      src = src.replaceAll("fill=\"".concat(fromColor, "\""), "fill=\"".concat(toColor, "\""));
    });
  }

  if (replaceStrokeColor) {
    replaceStrokeColor.forEach(function (item) {
      var _item3 = _rollupPluginBabelHelpers.slicedToArray(item, 2),
          fromColor = _item3[0],
          toColor = _item3[1];

      src = src.replaceAll("stroke=\"".concat(fromColor, "\""), "stroke=\"".concat(toColor, "\""));
    });
  }

  src = src.replace('xmlns="http://www.w3.org/2000/svg"', 'xmlns="http://www.w3.org/2000/svg" style="display: block"');
  return /*#__PURE__*/React__default["default"].createElement(Box__default["default"], _rollupPluginBabelHelpers["extends"]({}, props, {
    dangerouslySetInnerHTML: {
      __html: src
    },
    style: {
      display: 'inline-block'
    },
    className: className + ' ' + _className
  }));
};

exports["default"] = ImageWrapper;
